import { Trans } from '@lingui/macro';
import * as React from 'react';
import { newsLetterSubmitSuccessState, resetNewsLetterStates } from '../../state';
import { NewsLetterSuccessContainer, NewsLetterSuccessIcon, NewsLetterSuccessReturnButton } from './components';

export const NewsLetterSubmitSuccess = () => {
  React.useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;
    if (timeout != null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      resetNewsLetterStates();
      newsLetterSubmitSuccessState.set(false);
    }, 5000);
    return () => {
      if (timeout != null) {
        resetNewsLetterStates();
        newsLetterSubmitSuccessState.set(false);
        clearTimeout(timeout);
      }
    };
  }, []);
  return (
    <NewsLetterSuccessContainer>
      <NewsLetterSuccessIcon />
      <Trans>
        Inscription à la newsletter réussie!
      </Trans>
      <NewsLetterSuccessReturnButton />
    </NewsLetterSuccessContainer>
  );
};
